let timer = null
const events = ["mousemove", "keydown", "touchstart", "click"]

export function useInactivityWatcher(callback, timeout = 30000, vueInstance = null) {
  if (typeof callback !== "function") return

  // 重置计时器
  const resetTimer = () => {
    clearTimeout(timer)
    timer = setTimeout(() => {
      const path = vueInstance?.$route?.path || ""
      // 只在大厅页触发
      if (path.includes("/home")) {
        console.log("[popTimer] 30秒无操作，触发回调")
        callback()
      } else {
        console.log("[popTimer] 不在大厅页，忽略触发")
      }
    }, timeout)
  }

  // 添加事件监听
  const addListeners = () => {
    events.forEach(e => window.addEventListener(e, resetTimer))
  }

  // 移除事件监听
  const removeListeners = () => {
    events.forEach(e => window.removeEventListener(e, resetTimer))
  }

  // 启动监听
  addListeners()
  resetTimer()

  return {
    stop() {
      removeListeners()
      clearTimeout(timer)
      console.log("[popTimer] 已停止监听")
    },
  }
}